<script lang="ts">
import Auth from "./Auth.svelte";
import Menu from "./Menu.svelte";
import Stats from "./Stats.svelte";
import Typing from "./Typing.svelte";
import List from "./List.svelte";
import { supabase } from './supaBase';
import {statsData,currentPage} from './store'
import Item from "./Item.svelte";

supabase
.from('stats')
.on('INSERT', payload => {
	console.log('Change received!', payload)
	$statsData.push(payload.new)
})
.subscribe()

</script>
<main>

<h1>TypeGraph</h1>
<Menu></Menu>
<Auth></Auth>
{#if $currentPage === "Add"}
<Item></Item>
{/if}

{#if $currentPage === "Typing"}
<List></List>
<Typing></Typing>
<Stats></Stats>
{/if}
</main>

<style> 
    main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}
    h1{
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 1.4em;
		font-weight: 100;
	}

    @media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

</style>